import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import MyQR from "../qrCode/twofaQR";
import { AXIOS, api_key } from "../../config";
import Loader from "../loader/loader";
import { toast } from "react-toastify";
import { MdEmail } from "react-icons/md";
import SignIn from "../login/signin";
import TwoFactor from "./twoFactor";
import Update2fa from "./update2fa";
export default function Twofa() {
  const userDetails = useSelector((state: any) => state.auth.auth);
  const [url, setUrl] = useState(null);
  const [isLoading, setLoading] = useState<Boolean>(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [email, setEmail] = useState("");
  const [shows, setShows] = useState(false);
  const handleClos = () => setShows(false);
  const handleSho = () => setShows(true);

  let userid = sessionStorage.getItem("userid");  

  const getQRUrl = async () => {
    await AXIOS.post("/qr", { user_id: userid })
      .then((response) => {
        if (response.data.status == "success") {
          setUrl(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getQRUrl();
  }, []);

  const handleFaModel = async (reason: String, index: Number) => {
    setLoading(true);
    await AXIOS.post(`/getUserInfo`, {
      api_key: api_key,
      user_id: userid,
    }).then((response) => {
      if (response.data.status == "success") {
        setEmail(response.data.data.email);
      }
    });
    await AXIOS.post(`/sendMail`, {
      api_key: api_key,
      user_id: userid,
      reason: reason,
    })
      .then((response) => {
        if (response.data.status == "success") {
          toast.success("Pin code sent to Email", { icon: <MdEmail /> });
          setLoading(false);
          index == 1 ? handleShow() : handleSho();
        } else {
          toast.error(response.data.showableMessage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setLoading(false);
  };
  return (
    <div className="  row">
      <div className="col-12 d-flex justify-content-center align-items-center">
        <h1 className="mt-5 text-white">Two-factor authorization settings</h1>
      </div>
      <div className="col-12 d-flex justify-content-center align-items-center my-4">
        {url && <img src={url} width={100} height={100} />}
      </div>
      {isLoading == false ? (
        <div className="col-12 d-flex justify-content-center align-items-center my-4">
          <button
            className="btn btn-register mt-2"
            onClick={() => {
              handleFaModel("login_verification", 1);
            }}
          >
            Add 2Fa
          </button>
          <button
            className="btn btn-register mt-2 "
            onClick={() => {
              handleFaModel("update_2fa", 2);
            }}
          >
            Enable
          </button>
        </div>
      ) : (
        <Loader />
      )}

      {show && <TwoFactor show={show} handleClose={handleClose} data={email} />}
      {shows && (
        <Update2fa show={shows} handleClose={handleClos} data={email} />
      )}
    </div>
  );
}
